export default __webpack_public_path__ + "static/Vumography-BG4-d8af504e34e4a260fe32938787c1adb9.webp";